"use strict";

var _makeupNextId = _interopRequireDefault(require("makeup-next-id"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// REQUIRE
//const nextId = require('makeup-next-id').default;

// IMPORT

const listEl = document.getElementById("list");
const testForm = document.getElementById("testForm");
const inputEl = document.getElementById("prefix");
testForm.addEventListener("submit", e => {
  e.preventDefault();
  const listItem = document.createElement("li");
  const id = (0, _makeupNextId.default)(listItem, inputEl.value);
  listItem.innerText = `Item ${listEl.childNodes.length} (${id})`;
  console.log(`id: ${id}`);
  listEl.appendChild(listItem);
});